/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const ForecastQuantityPage = lazyLoad(
  () => import('./index'),
  module => module.ForecastQuantityPage
);
